// ProductLinks.js (child)
import React, { useState } from "react";
import styles from "./ProductLinks.module.scss";

function ProductLinks({
  productDescription,
  technicalDetails,
  additionalInformation,
  stock,
  stockLoading,
  stockError,
}) {
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const [isTechnicalOpen, setIsTechnicalOpen] = useState(false);
  const [isAdditionalOpen, setIsAdditionalOpen] = useState(false);
  const [isShippingOpen, setIsShippingOpen] = useState(false);
  const [isStockOpen, setIsStockOpen] = useState(false);
  const [isDeliveryOpen, setIsDeliveryOpen] = useState(false);

  let stockInfo;
  if (stockLoading) {
    stockInfo = "Checking stock availability...";
  } else if (stockError) {
    stockInfo = "Stock information unavailable.";
  } else if (stock > 0) {
    stockInfo = `${stock} items in stock.`;
  } else {
    stockInfo = "Out of stock.";
  }

  return (
    <div className={styles.productLinksContainer}>
      {/* Product Description Section */}
      <div className={styles.productLinkItem}>
        <div
          className={styles.productLinkHeader}
          onClick={() => setIsDescriptionOpen(!isDescriptionOpen)}
        >
          <span>Product Description</span>
          <span className={styles.icon}>{isDescriptionOpen ? "−" : "+"}</span>
        </div>
        <div
          className={`${styles.productLinkContent} ${
            isDescriptionOpen ? styles.active : ""
          }`}
        >
          <p>{productDescription}</p>
        </div>
      </div>

      {/* Technical Details Section */}
      {technicalDetails !== "" && technicalDetails != null && (
        <div className={styles.productLinkItem}>
          <div
            className={styles.productLinkHeader}
            onClick={() => setIsTechnicalOpen(!isTechnicalOpen)}
          >
            <span>Technical Details</span>
            <span className={styles.icon}>{isTechnicalOpen ? "−" : "+"}</span>
          </div>
          <div
            className={`${styles.productLinkContent} ${
              isTechnicalOpen ? styles.active : ""
            }`}
          >
            <p>{technicalDetails}</p>
          </div>
        </div>
      )}

      {/* Additional Information Section */}
      <div className={styles.productLinkItem}>
        <div
          className={styles.productLinkHeader}
          onClick={() => setIsAdditionalOpen(!isAdditionalOpen)}
        >
          <span>Additional Information</span>
          <span className={styles.icon}>{isAdditionalOpen ? "−" : "+"}</span>
        </div>
        <div
          className={`${styles.productLinkContent} ${
            isAdditionalOpen ? styles.active : ""
          }`}
        >
          <p>{additionalInformation}</p>
        </div>
      </div>

      {/* Shipping and Returns Section */}
      <div className={styles.productLinkItem}>
        <div
          className={styles.productLinkHeader}
          onClick={() => setIsShippingOpen(!isShippingOpen)}
        >
          <span>Shipping and Returns</span>
          <span className={styles.icon}>{isShippingOpen ? "−" : "+"}</span>
        </div>
        <div
          className={`${styles.productLinkContent} ${
            isShippingOpen ? styles.active : ""
          }`}
        >
          <p>
            Delivery is currently available domestically in Portugal or within
            Europe to specific countires using our delivery partner CTT. All
            available locations will be shown at checkout.
          </p>
          <p>For Returns, please see our returns policy found in the footer.</p>
        </div>
      </div>

      {/* Stock Availability Section */}
      <div className={styles.productLinkItem}>
        <div
          className={styles.productLinkHeader}
          onClick={() => setIsStockOpen(!isStockOpen)}
        >
          <span>Stock Availability</span>
          <span className={styles.icon}>{isStockOpen ? "−" : "+"}</span>
        </div>
        <div
          className={`${styles.productLinkContent} ${
            isStockOpen ? styles.active : ""
          }`}
        >
          <p>{stockInfo}</p>
        </div>
      </div>

      {/* Out of Stock Delivery Time Section */}
      <div className={styles.productLinkItem}>
        <div
          className={styles.productLinkHeader}
          onClick={() => setIsDeliveryOpen(!isDeliveryOpen)}
        >
          <span>Out of Stock Delivery Time</span>
          <span className={styles.icon}>{isDeliveryOpen ? "−" : "+"}</span>
        </div>
        <div
          className={`${styles.productLinkContent} ${
            isDeliveryOpen ? styles.active : ""
          }`}
        >
          <p>
            Typically the items take 4 weeks to be ready to deliver (it is
            possible for items to be in stock in less time).
          </p>

          <p>
            If you would like to know more information please contact {""}
            <a href="mailto:corkmatters.online@gmail.com">
              corkmatters.online@gmail.com
            </a>
          </p>


        </div>
      </div>
    </div>
  );
}

export default ProductLinks;
